import classNames from "classnames";
import { SearchIcon } from "~/common/icons/SearchIcon";

export function SearchSubmitButton() {
  return (
    <button
      type="submit"
      className={classNames(
        "tw:!inline-flex tw:!items-center tw:!justify-center tw:!px-4 tw:!h-[38px] tw:!transition-colors ",
        "tw:!font-medium tw:sm:!text-sm tw:!shadow-sm tw:!text-white tw:!bg-blue-500",
        "tw:!border tw:!border-blue-500",
        "tw:hover:!bg-blue-600 tw:hover:!border-blue-600",
        "tw:focus:!outline-none tw:focus:!ring-2 tw:focus:!ring-offset-2 tw:focus:!ring-blue-500",
        "tw:!rounded-md tw:!rounded-tl-none tw:!rounded-bl-none",
      )}
    >
      <SearchIcon className="tw:fill-white tw:h-4 tw:w-4" />
    </button>
  );
}
